<template>
    <div class="content">
        <div class="container">
            <h1 class="mb-5">
                Setting
            </h1>
            <nav-setting tab="general"></nav-setting>

            <div v-if="setting.verify_email !=1" class="alert alert-warning ">
                <div class="row">
                    <div class="col d-flex align-items-center">Verify Email:
                        {{setting.email_from}}
                    </div>
                    <div class="col text-right">
                        <button @click="verifyEmail()" class=" btn btn-primary">Verify</button>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col">
                    <div class="card-box">
                        <card-title>Store settings</card-title>
                        <div class="mt-3">
                            <strong>Store name</strong>
                            <input-edit id="website_name" v-model="setting.website_name"
                                        @change="save('website_name',$event)"/>
                        </div>
                        <div class="mt-3">
                            <strong>Time zone</strong>
                            <div class="form-group">
                                <select id="timezone" v-model="setting.timezone" class="form-control" name="timezone"
                                        @change="save('timezone', setting.timezone)">
                                    <option v-for="i in timezones" :key="i.value" :value="i.value">
                                        {{ i.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="mt-3">
                            <strong>Domain</strong>

                            <change-domain @update="setting.domain = $event" :txt="setting.domain_txt" :domain="setting.domain"></change-domain>
                        </div>
                        <div class="form-group mt-3">
                            <toggle-button :value="searchbar_on" :height="24" :margin="1" :sync="true"
                                           @change="save('searchbar_on',$event.value ? 1:0)"/>
                            Show store search bar
                        </div>
                    </div>


                    <div class="card-box">
                        <card-title>Logo</card-title>
                        <div class="mt-3">
                            <vue-dropzone v-if="setting.logo_desktop == '' || changeLogo == true" id="logoFile"
                                          :options="dropLogoOptions" :use-custom-slot="true"
                                          @vdropzone-removed-file="logoFile=''; changeLogo = false"
                                          @vdropzone-success="logoDone">
                                <div class="dropzone-custom-content">
                                    <h3 class="dropzone-custom-title">
                                        Logo
                                    </h3>
                                    <div class="subtitle">
                                        Drag and drop png file. <br> (Recommended size: Width
                                        400-850px /
                                        Height 100-125px)
                                    </div>
                                </div>
                            </vue-dropzone>
                            <img v-if="setting.logo_desktop != '' && changeLogo == false" class="img-thumbnail"
                                 :src="logoUrl" alt="" @click="changeLogo = true">
                        </div>
                    </div>

                    <div class="card-box">
                        <card-title>Favicon (.ico .png format)</card-title>
                        <div class="mt-3">
                            <vue-dropzone v-if="setting.favicon == '' || changeFavicon == true" id="favicon" i
                                          :options="dropFaviconOptions" :use-custom-slot="true"
                                          @vdropzone-removed-file="faviconFile=''; changeFavicon = false"
                                          @vdropzone-success="faviconDone">
                                <div class="dropzone-custom-content">
                                    <h3 class="dropzone-custom-title">
                                        Favicon
                                    </h3>
                                    <div class="subtitle">
                                        Drag and drop png art files anywhere in this box or click
                                        here to upload a front image
                                    </div>
                                </div>
                            </vue-dropzone>
                            <img v-if="setting.favicon != '' && changeFavicon == false" class="img-thumbnail"
                                 :src="faviconUrl" alt="" @click="changeFavicon = true">
                        </div>
                    </div>
                    <div class="card-box">
                        <card-title>Email Settings</card-title>
                        <div class="form-group mt-3">
                            <toggle-button :value="email_cart_remind_on" :height="24" :margin="1" :sync="true"
                                           @change="save('email_cart_remind_on',$event.value ? 1:0)"/>
                            Enable automatic abandoned cart emails
                        </div>
                    </div>
                    <div class="card-box">
                        <card-title>Support</card-title>
                        <div class="mt-3">
                            <strong>Name</strong>
                            <input-edit v-model="setting.email_name" @change="save('email_name',$event)"/>
                        </div>
                        <div class="mt-3">
                            <strong>Email</strong>
                            <change-email ref="email" @verify="setting.verify_email = $event"
                                          @update="setting.email_from = $event"
                                          :verify_email.sync="setting.verify_email"
                                          :email="setting.email_from"></change-email>
                        </div>
                        <!-- <div class="mt-3">
                             <strong>Email</strong>
                             <input-edit v-model="setting.email_from" @change="save('email_from',$event)"/>
                         </div>-->
                        <div class="mt-3">
                            <strong>Phone</strong>
                            <input-edit v-model="setting.website_hotline" @change="save('website_hotline',$event)"/>
                        </div>
                        <div class="mt-3">
                            <strong>Address</strong>
                            <input-edit v-model="setting.website_address" @change="save('website_address',$event)"/>
                        </div>
                    </div>


                </div>


                <div class="col">
                    <div class="card-box">
                        <card-title>Team</card-title>

                        <team/>
                    </div>

                    <div class="card-box">
                        <card-title>Default pixels</card-title>
                        <div class="mt-3">
                            <strong>New Facebook pixel</strong>
                            <input-edit v-model="setting.facebook_pixel" @change="save('facebook_pixel',$event)"/>
                            <small>Separate each pixel with a comma. else.
                            </small>
                        </div>
                        <div class="mt-3">
                            <strong>Google Tag Manager ID</strong>
                            <input-edit v-model="setting.google_tag_manager_id"
                                        @change="save('google_tag_manager_id',$event)"/>
                        </div>
                        <div class="mt-3">
                            <strong>Google Merchant Center Verification ID</strong>
                            <input-edit v-model="setting.google_merchant_verify_id"
                                        @change="save('google_merchant_verify_id',$event)"/>
                        </div>
                    </div>
                    <div class="card-box">
                        <card-title>Miscellaneous</card-title>
                        <div class="form-group mt-3">
                            <toggle-button :value="countdown_on" :height="24" :margin="1" :sync="true"
                                           @change="save('countdown_on',$event.value ? 1:0)"/>
                            Enable countdown timer
                        </div>
                        <div class="form-group mt-3">
                            <toggle-button :value="make_it_personal_on" :height="24" :margin="1" :sync="true"
                                           @change="save('make_it_personal_on',$event.value ? 1:0)"/>
                            Enable Make It Personal
                        </div>


                    </div>

                    <div class="card-box">
                        <p class="m-0 title">
                            Payment
                        </p>
                        <div class="form-group mt-3">
                            <toggle-button :value="paypal_on" :height="24" :margin="1" :sync="true"
                                           @change="save('paypal_on',$event.value ? 1:0)"/>
                            Enable Paypal
                        </div>
                        <div class="mt-3">
                            <strong>Paypal Client</strong>
                            <input-edit v-model="setting.paypal_client" @change="save('paypal_client',$event)"/>
                        </div>
                        <div class="mt-3">
                            <strong>Paypal Client Secret</strong>
                            <input-edit v-model="setting.paypal_client_secret"
                                        @change="save('paypal_client_secret',$event)"/>
                        </div>
                        <hr>
                        <div class="form-group mt-3">
                            <toggle-button :value="stripe_on" :height="24" :margin="1" :sync="true"
                                           @change="save('stripe_on',$event.value ? 1:0)"/>
                            Enable Stripe
                        </div>
                        <div class="mt-3">
                            <strong>Stripe Publish Key</strong>
                            <input-edit v-model="setting.stripe_publishable_key"
                                        @change="save('stripe_publishable_key',$event)"/>
                        </div>
                        <div class="mt-3">
                            <strong>Stripe Secret</strong>
                            <input-edit v-model="setting.stripe_secret_key"
                                        @change="save('stripe_secret_key',$event)"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import InputEdit from "@/components/InputEdit";
    import TimeZone from "@/lib/Timezone"
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import vue2Dropzone from 'vue2-dropzone'
    import Team from "@/components/Team";
    import CardTitle from "@/components/CardTitle";
    import NavSetting from "../components/NavSetting";
    import ChangeDomain from "../components/ChangeDomain";
    import ChangeEmail from "../components/ChangeEmail";

    export default {
        name: "Setting",
        components: {
            ChangeEmail,
            ChangeDomain,
            NavSetting,
            CardTitle,
            Team,
            InputEdit,
            VueDropzone: vue2Dropzone
        },
        data: function () {
            return {
                customToolbar: {
                    height: 350,
                    menubar: false,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor textcolor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar: 'undo redo | formatselect | bold italic forecolor  backcolor image  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat code '
                },
                changeFavicon: false,
                changeLogo: false,
                faviconFile: '',
                logoFile: '',
                setting: {},
                timezones: TimeZone,
                dropLogoOptions: {
                    url: this.$config.api + 'store/logo',
                    thumbnailWidth: 400,
                    addRemoveLinks: true,
                    headers: {
                        'Authorization': this.$http.defaults.headers.common['Authorization']
                    }
                },
                dropFaviconOptions: {
                    url: this.$config.api + 'store/favicon',
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    headers: {
                        'Authorization': this.$http.defaults.headers.common['Authorization']
                    }
                },
            }
        },

        computed: {
            logoUrl: function () {
                if (this.setting.logo_desktop)
                    return this.$config.images + this.setting.logo_desktop;
                return ''
            },
            faviconUrl: function () {
                if (this.setting.favicon)
                    return this.$config.images + this.setting.favicon;
                return ''
            },
            email_cart_remind_on: function () {
                return this.setting.email_cart_remind_on == 1 ? true : false;
            },
            countdown_on: function () {
                return this.setting.countdown_on == 1 ? true : false;
            },
            searchbar_on: function () {
                return this.setting.searchbar_on == 1 ? true : false;
            },
            paypal_on: function () {
                return this.setting.paypal_on == 1 ? true : false;
            },
            stripe_on: function () {
                return this.setting.stripe_on == 1 ? true : false;
            },
            make_it_personal_on: function () {
                return this.setting.make_it_personal_on == 1 ? true : false;
            }
        },
        mounted: async function () {
            this.$store.commit('ACTIVE_SIDEBAR', 'setting')
            await this.load()
        },

        methods: {
            faviconDone: function (file, response) {
                if (response.status) {
                    this.faviconFile = response.url
                } else {
                    this.$swal(response.message);
                }
            },
            logoDone: function (file, response) {
                if (response.status) {
                    this.logoFile = response.url
                } else {
                    this.$swal(response.message);
                }
            },

            verifyEmail: function () {
                this.$refs.email.verifyEmail()
            },

            save: function (name, value) {

                let update = {
                    option_name: name,
                    option_value: value
                }
                this.$http.post(this.$config.api + 'store/setting', update)
            },
            load: async function () {
                let vm = this
                await this.$http.get(this.$config.api + 'store/setting').then(function (res) {
                    vm.setting = res.data
                })
            }
        }
    }
</script>

<style scoped>

</style>